import api from './api';

// ========================
// DASHBOARD SERVICE
// ========================
export const dashboardService = {
  // The route is /dashboard, not /dashboard/overview — this 404'd, and since it is
  // the dashboard's primary fetch, nothing on the page loaded.
  overview: () => api.get('/dashboard'),
  expenseTrend: (params) => api.get('/dashboard/expense-trend', { params }),
  labourSummary: (params) => api.get('/dashboard/labour-summary', { params }),
  projectSummary: (projectId, params) => api.get(`/dashboard/project-summary/${projectId}`, { params }),
  budgetBurndown: (projectId) => api.get(`/dashboard/budget-burndown/${projectId}`),
  portfolio: () => api.get('/dashboard/portfolio'),
  profitability: () => api.get('/dashboard/profitability'),
  portfolioAnomalies: (params) => api.get('/dashboard/anomalies', { params }),
  portfolioProgress: () => api.get('/dashboard/progress'),
  portfolioWastage: () => api.get('/dashboard/wastage'),
  todayPulse: () => api.get('/dashboard/today'),
};

// ========================
// REPORTS SERVICE
// ========================
/**
 * JSON reports return the usual {success, message, data} envelope; `data` is the
 * payload and is not paginated.
 *
 * Exports are a different contract: GET reports/{type}?format=pdf|xlsx returns a
 * FILE, not JSON. `type` is one of EXPORT_TYPES below. The old reports/export/*
 * routes this file used to call never existed on the server, and CSV is not
 * supported at all — the API only renders PDF and XLSX.
 */
export const EXPORT_TYPES = [
  'attendance',
  'expenses',
  'materials',
  'progress',
  'safety',
  'billing',
  'milestones',
];

export const EXPORT_FORMATS = ['pdf', 'xlsx'];

export const reportsService = {
  daySummary: (projectId, params) => api.get(`/projects/${projectId}/reports/day-summary`, { params }),
  costBreakdown: (projectId, params) => api.get(`/projects/${projectId}/reports/cost-breakdown`, { params }),
  materialConsumption: (projectId, params) => api.get(`/projects/${projectId}/reports/material-consumption`, { params }),

  // type: attendance | expenses | materials | progress | safety | billing | milestones
  // format: pdf | xlsx
  exportReport: (projectId, type, { format = 'pdf', ...params } = {}) =>
    api.get(`/projects/${projectId}/reports/${type}`, {
      params: { ...params, format },
      responseType: 'blob',
    }),
};

export const searchService = {
  search: (params) => api.get('/search', { params }),
};

// ========================
// NOTIFICATION SERVICE
// ========================
export const notificationService = {
  list: (params) => api.get('/notifications', { params }),
  unreadCount: () => api.get('/notifications/unread-count'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
};

// ========================
// PLATFORM ADMIN SERVICE (super_admin only)
// ========================
export const platformService = {
  overview: () => api.get('/platform/overview'),
  signups: (params) => api.get('/platform/signups', { params }),
  organizations: (params) => api.get('/platform/organizations', { params }),
  activity: (params) => api.get('/platform/activity', { params }),
  users: (params) => api.get('/platform/users', { params }),
};

// ========================
// CLIENT PORTAL SERVICE
// ========================
export const clientPortalService = {
  listProjects: () => api.get('/client-portal/projects'),
  projectSummary: (projectId) => api.get(`/client-portal/projects/${projectId}/summary`),
  projectFeed: (projectId, params) => api.get(`/client-portal/projects/${projectId}/feed`, { params }),
  projectMilestones: (projectId) => api.get(`/client-portal/projects/${projectId}/milestones`),
  projectPhotos: (projectId, params) => api.get(`/client-portal/projects/${projectId}/photos`, { params }),
};
